import { Redirect } from 'react-router-dom'
import { remoteConfig } from '@/firebase'
import useWhiteLabelProgramId from '@/hooks/whitelabel/useWhiteLabelProgramId'
import { useAppSelector } from '@/hooks'
import { selectUserVehicles } from '@/selectors'

export default function OnboardingSurvey() {
  const home = useAppSelector((state) => state.homes.selectedHome)
  const whitelabelId = useWhiteLabelProgramId()
  const avaId = remoteConfig?.getWhitelabelId('ava')

  if (whitelabelId && avaId && whitelabelId === avaId) {
    return <Redirect to="/ava/onboarding/address-select" />
  }

  if (!home) {
    return <Redirect to="/onboarding/address-select" />
  }

  return <Redirect to="/onboarding" />
}
